import {
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CenteredSpinner from "@/shared/components/centered-spinner";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useIdentity from "@/features/ui/hooks/use-identity";
import useGetTransportation from "@/features/transportations/hooks/use-get-transportation";
import SummaryRows, {
  SummaryRow,
} from "@/features/line-sheet-sets/detail/summary-rows";

interface Props {
  transportationId: number;
  isOpen: boolean;
  onClose: () => void;
}

// (부티크) 오더 상세의 운송/통관 탭에서 행을 누르면 — 상세 페이지 대신 핵심 항목만 보여준다.
export default function BoutiqueTransportationSummaryModal({
  transportationId,
  isOpen,
  onClose,
}: Props) {
  const identity = useIdentity();
  const { tTitle } = useI18nHelper();

  const { data: transportation } = useGetTransportation(
    identity?.company
      ? {
          by: identity.company.type,
          companyId: identity.company.id,
          transportationId,
        }
      : undefined,
    {},
    { revalidateOnFocus: false }
  );

  // 부티크에게는 국내 배송에 필요한 것만 — 국내배송사·송장번호와 수령처(이름·연락처·주소).
  const rows = useMemo((): SummaryRow[] => {
    if (!transportation) {
      return [];
    }
    return [
      {
        label: tTitle("domestic_carrier_name"),
        value: transportation.domesticCarrierName,
      },
      {
        label: tTitle("domestic_tracking_number"),
        value: transportation.domesticTrackingNumber,
      },
      {
        label: tTitle("recipient_name"),
        value: transportation.shippedToRecipientName,
      },
      { label: tTitle("contact"), value: transportation.shippedToContact },
      {
        label: tTitle("shipped_to_address"),
        value: transportation.shippedToAddress,
      },
    ];
  }, [transportation, tTitle]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"lg"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize={"16px"} fontWeight={"700"}>
          {tTitle("transportation")}
        </ModalHeader>
        <ModalBody>
          {transportation ? <SummaryRows rows={rows} /> : <CenteredSpinner />}
        </ModalBody>
        <ModalFooter>
          <Grid>
            <AppButton onClick={onClose}>{tTitle("close")}</AppButton>
          </Grid>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
